import {Component, Input} from '@angular/core';

@Component({
    selector: 'sites-component',
    templateUrl: 'sites.component.html'
})
export class SitesComponent {
    @Input() sites;

    constructor() {}
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/sites.component.ts